import {
  PROJECT_STATUSES,
  PROJECT_STATUS_WORKFLOW,
  TEST_TYPES_LABELS,
} from 'Constants';
import { format, parseISO } from 'date-fns';
import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton, Link, Stack, Typography } from '@mui/material';

import { ScenariosTableSingleTest } from 'Components/Scenarios';
import Floorplan from 'Components/SingleTest/Elements/Floorplan';
import { useTestContext } from 'Components/SingleTest/context';

import { isSafetracesAdmin, isViewer } from 'Config/roles';

const MiniSurvey = (props) => {
  const {
    filteredTest,
    originPointsList,
    samplePointsList,
    platekind,
    sprayer,
    surveydate,
    comments,
    intervalCount,
    intervalDuration,
    preparedScenariosList,
    segmentId,
    segment,
    sprayers,
    projectId,
    floorPlanPlacementURL,
    airSamplerRate,
    projectStatus,
  } = props;

  const { openEditModal, disableEdits } = useTestContext();
  const overrideEditPermissionSafetracesAdminIgroneWorkflow =
    isSafetracesAdmin();
  const editDetailsDisabled =
    PROJECT_STATUS_WORKFLOW.indexOf(projectStatus) >=
    PROJECT_STATUS_WORKFLOW.indexOf(PROJECT_STATUSES.EXECUTED);

  return (
    <Stack direction="column" mt={2}>
      <Grid container spacing={2}>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Test Type:</b> {TEST_TYPES_LABELS[filteredTest.testtype]}
          </Typography>
        </Grid>

        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Sample Type:</b>
            {' Filter'}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Typography variant={'body1'}>
            <b>Air Sample Rate (L/min)*:</b> {airSamplerRate}{' '}
            {!isViewer() && !disableEdits && !editDetailsDisabled && (
              <IconButton
                aria-label="Edit sample rate"
                size="small"
                onClick={() => {
                  openEditModal({
                    type: 'sample_rate',
                    value: airSamplerRate,
                    testId: filteredTest.testid,
                  });
                }}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
            )}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>No. of OP:</b>{' '}
            {originPointsList.length > 0 ? originPointsList.length : ''}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>No. of SP:</b>{' '}
            {samplePointsList.length > 0 ? samplePointsList.length : ''}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={6}>
          <Typography variant={'body1'}>
            {segment.floorplan && (
              <>
                {!isSafetracesAdmin() && !isViewer() && !disableEdits && (
                  <b>
                    Floorplan (
                    <Link href={floorPlanPlacementURL}>Manage OPs/SPs</Link>)
                  </b>
                )}
                {!isSafetracesAdmin() && (isViewer() || disableEdits) ? (
                  <b>
                    Floorplan (
                    <Link href={floorPlanPlacementURL}>View OPs/SPs</Link>)
                  </b>
                ) : null}
                {isSafetracesAdmin() &&
                projectStatus !== PROJECT_STATUSES.PUBLISHED ? (
                  <b>
                    Floorplan (
                    <Link href={floorPlanPlacementURL}>Manage OPs/SPs</Link>)
                  </b>
                ) : null}
                {isSafetracesAdmin() &&
                projectStatus === PROJECT_STATUSES.PUBLISHED ? (
                  <b>
                    Floorplan (
                    <Link href={floorPlanPlacementURL}>View OPs/SPs</Link>)
                  </b>
                ) : null}{' '}
              </>
            )}
            {!segment.floorplan && (
              <>
                <b>Floorplan</b>{' '}
              </>
            )}
            <Floorplan
              projectId={projectId}
              buildingId={filteredTest.buildingid || ''}
              filteredTest={filteredTest}
              segment={segment}
              editDisabled={disableEdits || editDetailsDisabled}
            />
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Tag Series:</b> {platekind}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Sprayer:</b> {sprayer}{' '}
            {!isViewer() && !disableEdits && !editDetailsDisabled && (
              <IconButton
                aria-label="Edit sprayer"
                size="small"
                onClick={() => {
                  openEditModal({
                    type: 'sprayer',
                    value: sprayer,
                    testId: filteredTest.testid,
                    data: { sprayers },
                  });
                }}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
            )}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Interval Count:</b> {intervalCount}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Interval Duration:</b> {intervalDuration}
          </Typography>
        </Grid>
        <Grid item xs={6} lg={3}>
          <Typography variant={'body1'}>
            <b>Survey date:</b>{' '}
            {surveydate ? format(parseISO(surveydate), 'MMM do, yyyy') : ''}{' '}
            {!isViewer() && !disableEdits && !editDetailsDisabled && (
              <IconButton
                aria-label="Edit survey date"
                size="small"
                onClick={() => {
                  openEditModal({
                    type: 'surveydate',
                    value: surveydate,
                    testId: filteredTest.testid,
                    data: { segment },
                  });
                }}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} lg={9}>
          <Typography variant={'body1'}>
            <b>Comments:</b> {comments}{' '}
            {overrideEditPermissionSafetracesAdminIgroneWorkflow ||
            (!isViewer() && !disableEdits && !editDetailsDisabled) ? (
              <IconButton
                aria-label="Edit comments"
                size="small"
                onClick={() => {
                  openEditModal({
                    type: 'comments',
                    value: comments,
                    testId: filteredTest.testid,
                    data: { segmentId },
                  });
                }}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>
            ) : null}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant={'body1'} sx={{ mb: 2 }}>
            <b>Tags</b>
          </Typography>
          <ScenariosTableSingleTest
            scenarios={preparedScenariosList}
            originPoints={originPointsList}
            projectId={projectId}
            test={filteredTest}
            editDisabled={disableEdits}
            projectStatus={projectStatus}
          ></ScenariosTableSingleTest>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default MiniSurvey;
